import { useQuery } from '@tanstack/react-query';

import { fetchPropertyAssessmentEligibility } from 'api/propertyAssessment';
import usePhotoSession from './usePhotoSession';

export const getKey = propertyId => ['can-assess', Number(propertyId)];

const useCanAssessProperty = (photoSessionId, options) => {
  const { data: photoSession } = usePhotoSession(photoSessionId);

  return useQuery({
    queryKey: getKey(photoSession?.house?.id),
    queryFn: () => fetchPropertyAssessmentEligibility(photoSession?.house?.id),
    enabled: !!photoSession?.house?.id,
    select: data => data.eligibility && photoSession?.dueDate > new Date(2023, 0, 17),
    ...options,
  });
};

export default useCanAssessProperty;
